<template>
	<span class="lazy-image"></span>
</template>

<script>
export default{
	name: 'LazyImage',
	props: ['src', 'alt'],
	data: function(){
		return {
			loaded: false
		}
	},
	methods: {
		isOnRect: function(){
			var el = this.$el;
			var rect = el.getBoundingClientRect();
			var parent = el.parentNode;

			if(rect.top <= (window.innerHeight + 200)){

				if(!this.loaded){
					var img = document.createElement('img');

					img.src = this.src;
					img.alt = this.alt;

					parent.appendChild(img);
					parent.removeChild(el);

					this.loaded = true;
				}
			}
		}
	},
	mounted : function(){
		var isOnrect = this.isOnRect;

		isOnrect();

		window.addEventListener('scroll', function(){
			isOnrect();
		});
	}
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/LazyImage.vue